import "./RaikoSegmentSelect.scss"


export default function RaikoSegmentSelect(
    {
        items = [],
        value,
        setValue
    }) {
    return (
        <section className={"segmentSelectBaseContainer"}>
            {
                items && items.length > 0 && items.map((item, index) => {
                    return <div id={item.id} key={index}
                                className={`segmentSelectItem ${value === item.id ? "segmentSelectItemActive" : ""} `}
                                onClick={_ => {
                                    setValue(item.id)
                                }}>
                        {item.title}
                    </div>
                })
            }
        </section>
    )
}

export function raikoSegmentSelectItemGenerator(id, title) {
    return {
        id,
        title,
    }
}
